import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CMPFormInputText from '../../../../common/Forms/CMPFormTextField';
import CMPInputDropdown from '../../../../common/Forms/CMPInputDropdown';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCounselingStaffAssigned,
  setParticipant2,
  setParticipant5,
  setCss2,
  setCss5,
  setScss2,
  setScss5,
  setRvwDate2,
  setRvwDate5,
} from '../../../../../redux/episode/cmpTab/cmpForm/cmpSlice';

const Section2 = (props) => {
  const dispatch = useDispatch();
  const { control, defaultValue, register, errors } = props;

  const cmpReferenceData = useSelector((state) => state.cmpReferenceData);

  const { firstParticipantList, participantList, counselingStaffAssignedList, cssOrScssList } =
    cmpReferenceData;

  return (
    <Grid item xs={12} sm={4}>
      <CMPInputDropdown
        name='participant2'
        control={control}
        options={firstParticipantList}
        defaultId={defaultValue?.participant2}
        register={register('participant2', {
          onChange: (e) => dispatch(setParticipant2(e.target.value)),
        })}
        label='Participant'
      />
      <CMPInputDropdown
        name='css2'
        control={control}
        options={cssOrScssList}
        defaultId={defaultValue?.css2}
        cssOrScssList={true}
        register={register('css2', {
          onChange: (e) => dispatch(setCss2(e.target.value)),
        })}
        label='Css'
      />
      <CMPInputDropdown
        name='scss2'
        control={control}
        options={cssOrScssList}
        defaultId={defaultValue?.scss2}
        cssOrScssList={true}
        register={register('scss2', {
          onChange: (e) => dispatch(setScss2(e.target.value)),
        })}
        label='Scss'
      />
      <CMPInputDropdown
        name='rvwDate2'
        type='date'
        control={control}
        shrink={true}
        register={register('rvwDate2', {
          onBlur: (e) => dispatch(setRvwDate2(e.target.value)),
        })}
        label='Date'
      />
      <CMPInputDropdown
        name='participant5'
        control={control}
        options={firstParticipantList}
        defaultId={defaultValue?.participant5}
        register={register('participant5', {
          onChange: (e) => dispatch(setParticipant5(e.target.value)),
        })}
        label='Participant'
      />
      <CMPInputDropdown
        name='css5'
        control={control}
        options={cssOrScssList}
        defaultId={defaultValue?.css5}
        cssOrScssList={true}
        register={register('css5', {
          onChange: (e) => dispatch(setCss5(e.target.value)),
        })}
        label='Css'
      />
      <CMPInputDropdown
        name='scss5'
        control={control}
        options={cssOrScssList}
        defaultId={defaultValue?.scss5}
        cssOrScssList={true}
        register={register('scss5', {
          onChange: (e) => dispatch(setScss5(e.target.value)),
        })}
        label='Scss'
      />
      <CMPFormInputText
        name='rvwDate5'
        type='date'
        control={control}
        shrink={true}
        register={register('rvwDate5', {
          onBlur: (e) => dispatch(setRvwDate5(e.target.value)),
        })}
        label='Date'
      />
      <hr />
      <Box mt={2}>
        <CMPInputDropdown
          name='counselingStaffAssigned'
          control={control}
          options={counselingStaffAssignedList}
          defaultId={defaultValue?.counselingStaffAssigned}
          cssOrScssList={true}
          errors={!!errors.counselingStaffAssigned}
          helperText={errors?.counselingStaffAssigned?.message}
          register={register('counselingStaffAssigned', {
            onChange: (e) => dispatch(setCounselingStaffAssigned(e.target.value)),
          })}
          label='Counseler'
        />
      </Box>  
    </Grid>
  );
};

export default Section2;
